import {
  fetchActivityEntryLogs,
  fetchChurchActivityEntryForm,
  fetchDistrictActivityEntryForm,
  fetchNationActivityEntryForm,
  fetchChurchActivityEntryPrefill,
  fetchDistrictActivityEntryPrefill,
  fetchNationActivityEntryPrefill,
} from '../api/activityEntryApi';
import ApiResponse from '@core/types/apiResponse';
import type {
  ActivityEntryLogsQueryParams,
  ActivityEntryStatusLog,
  ActivityEntryPrefillCandidatesResponse,
  ActivityEntryPrefillValuesResponse,
} from '../types/activityEntry';
import type { ActivityEntryScope } from '../hooks/useActivityEntryAction';

export type ActivityEntryFormFetchParams = {
  scope: ActivityEntryScope;
  entityId: number;
  reportTemplateId: number;
  reportTagId: number;
  page?: number;
  perPage?: number;
};

export const fetchActivityEntryFormAsync = async (
  params: ActivityEntryFormFetchParams
): Promise<ApiResponse<any>> => {
  const { scope, entityId, reportTemplateId, reportTagId, page, perPage } = params;

  if (scope === 'district') {
    return fetchDistrictActivityEntryForm({
      districtId: entityId,
      reportTemplateId,
      reportTagId,
      page,
      perPage,
    });
  }

  if (scope === 'nation') {
    return fetchNationActivityEntryForm({
      nationId: entityId,
      reportTemplateId,
      reportTagId,
      page,
      perPage,
    });
  }

  return fetchChurchActivityEntryForm({
    churchId: entityId,
    reportTemplateId,
    reportTagId,
    page,
    perPage,
  });
};

export type ActivityEntryPrefillFetchParams = {
  scope: ActivityEntryScope;
  entityId: number;
  reportTemplateId: number;
  reportTagId: number;
  sourceReportTagId?: number;
};

export const fetchActivityEntryPrefillAsync = async (
  params: ActivityEntryPrefillFetchParams
): Promise<
  ApiResponse<ActivityEntryPrefillCandidatesResponse | ActivityEntryPrefillValuesResponse>
> => {
  const { scope, entityId, reportTemplateId, reportTagId, sourceReportTagId } = params;
  const query = { reportTemplateId, reportTagId, sourceReportTagId };

  if (scope === 'district') {
    return fetchDistrictActivityEntryPrefill(entityId, query);
  }
  if (scope === 'nation') {
    return fetchNationActivityEntryPrefill(entityId, query);
  }
  return fetchChurchActivityEntryPrefill(entityId, query);
};

export type ActivityEntryLogsFetchParams = {
  scope: ActivityEntryScope;
  entityId: number;
  params: ActivityEntryLogsQueryParams;
};

export const fetchActivityEntryLogsAsync = async ({
  scope,
  entityId,
  params,
}: ActivityEntryLogsFetchParams): Promise<ApiResponse<ActivityEntryStatusLog[]>> => {
  return fetchActivityEntryLogs(scope, entityId, params);
};
